import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPermissions {
  manage_setting_permissions_view: boolean;
  manage_iti_center_permissions_create: boolean;
  manage_iti_center_permissions_edit: boolean;
  manage_iti_center_permissions_view: boolean;
  manage_iti_center_permissions_delete: boolean;
  manage_iti_center_permissions_import: boolean;
  manage_iti_center_permissions_export: boolean;
  manage_district_permissions_create: boolean;
  manage_district_permissions_edit: boolean;
  manage_district_permissions_delete: boolean;
  manage_district_permissions_view: boolean;
  manage_district_permissions_import: boolean;
  manage_district_permissions_export: boolean;
  manage_year_permissions_create: boolean;
  manage_year_permissions_edit: boolean;
  manage_year_permissions_delete: boolean;
  manage_year_permissions_view: boolean;
  manage_center_type_permissions_create: boolean;
  manage_center_type_permissions_edit: boolean;
  manage_center_type_permissions_delete: boolean;
  manage_center_type_permissions_view: boolean;
  manage_trade_permissions_create: boolean;
  manage_trade_permissions_edit: boolean;
  manage_trade_permissions_delete: boolean;
  manage_trade_permissions_view: boolean;
  manage_trade_permissions_import: boolean;
  manage_trade_permissions_export: boolean;
  manage_bundle_type_permissions_create: boolean;
  manage_bundle_type_permissions_edit: boolean;
  manage_bundle_type_permissions_delete: boolean;
  manage_bundle_type_permissions_view: boolean;
  manage_role_permissions_create: boolean;
  manage_role_permissions_edit: boolean;
  manage_role_permissions_delete: boolean;
  manage_role_permissions_view: boolean;
  manage_user_permissions_create: boolean;
  manage_user_permissions_edit: boolean;
  manage_user_permissions_delete: boolean;
  manage_user_permissions_view: boolean;
  manage_exam_timetable_permissions_create: boolean;
  manage_exam_timetable_permissions_edit: boolean;
  manage_exam_timetable_permissions_delete: boolean;
  manage_exam_timetable_permissions_view: boolean;
  manage_notice_board_permissions_create: boolean;
  manage_notice_board_permissions_edit: boolean;
  manage_notice_board_permissions_delete: boolean;
  manage_notice_board_permissions_view: boolean;
  manage_doubt_permissions_answer: boolean;
  manage_doubt_permissions_view: boolean;
  manage_student_waiting_permissions_create: boolean;
  manage_student_waiting_permissions_edit: boolean;
  manage_student_waiting_permissions_delete: boolean;
  manage_student_waiting_permissions_view: boolean;
  manage_student_waiting_permissions_import: boolean;
  manage_student_waiting_permissions_actions: boolean;
  manage_student_approved_permissions_create: boolean;
  manage_student_approved_permissions_edit: boolean;
  manage_student_approved_permissions_delete: boolean;
  manage_student_approved_permissions_view: boolean;
  manage_student_approved_permissions_actions: boolean;
  manage_student_rejected_permissions_create: boolean;
  manage_student_rejected_permissions_edit: boolean;
  manage_student_rejected_permissions_delete: boolean;
  manage_student_rejected_permissions_view: boolean;
  manage_student_rejected_permissions_actions: boolean;
  manage_curriculum_permissions_create: boolean;
  manage_curriculum_permissions_edit: boolean;
  manage_curriculum_permissions_delete: boolean;
  manage_curriculum_permissions_view: boolean;
  manage_all_courses_permissions_create: boolean;
  manage_all_courses_permissions_edit: boolean;
  manage_all_courses_permissions_delete: boolean;
  manage_all_courses_permissions_view: boolean;
  manage_course_bundles_permissions_create: boolean;
  manage_course_bundles_permissions_edit: boolean;
  manage_course_bundles_permissions_delete: boolean;
  manage_course_bundles_permissions_view: boolean;
  manage_questions_permissions_create: boolean;
  manage_questions_permissions_edit: boolean;
  manage_questions_permissions_delete: boolean;
  manage_questions_permissions_view: boolean;
  manage_questions_permissions_import: boolean;
  manage_quiz_permissions_create: boolean;
  manage_quiz_permissions_edit: boolean;
  manage_quiz_permissions_delete: boolean;
  manage_quiz_permissions_view: boolean;
  manage_exam_permissions_create: boolean;
  manage_exam_permissions_edit: boolean;
  manage_exam_permissions_delete: boolean;
  manage_exam_permissions_view: boolean;
  manage_grand_test_permissions_create: boolean;
  manage_grand_test_permissions_edit: boolean;
  manage_grand_test_permissions_delete: boolean;
  manage_grand_test_permissions_view: boolean;
  manage_super_grand_test_permissions_create: boolean;
  manage_super_grand_test_permissions_edit: boolean;
  manage_super_grand_test_permissions_delete: boolean;
  manage_super_grand_test_permissions_view: boolean;
  manage_ebook_permissions_create: boolean;
  manage_ebook_permissions_edit: boolean;
  manage_ebook_permissions_delete: boolean;
  manage_ebook_permissions_view: boolean;
  manage_study_material_permissions_create: boolean;
  manage_study_material_permissions_edit: boolean;
  manage_study_material_permissions_delete: boolean;
  manage_study_material_permissions_view: boolean;
  manage_assignment_permissions_create: boolean;
  manage_assignment_permissions_edit: boolean;
  manage_assignment_permissions_delete: boolean;
  manage_assignment_permissions_view: boolean;
  manage_resource_permissions_create: boolean;
  manage_resource_permissions_edit: boolean;
  manage_resource_permissions_delete: boolean;
  manage_resource_permissions_view: boolean;
  manage_trade_time_table_permissions_create: boolean;
  manage_trade_time_table_permissions_edit: boolean;
  manage_trade_time_table_permissions_delete: boolean;
  manage_trade_time_table_permissions_view: boolean;
  manage_examination_guideline_permissions_create: boolean;
  manage_examination_guideline_permissions_edit: boolean;
  manage_examination_guideline_permissions_delete: boolean;
  manage_examination_guideline_permissions_view: boolean;
  manage_live_session_permissions_create: boolean;
  manage_live_session_permissions_view: boolean;
  manage_live_session_permissions_edit: boolean;
  manage_live_session_permissions_delete: boolean;
  manage_discussion_forum_permissions_create: boolean;
  manage_discussion_forum_permissions_edit: boolean;
  manage_discussion_forum_permissions_delete: boolean;
  manage_discussion_forum_permissions_view: boolean;
}

const initialState: IPermissions = {
  manage_setting_permissions_view: false,
  manage_iti_center_permissions_create: false,
  manage_iti_center_permissions_edit: false,
  manage_iti_center_permissions_view: false,
  manage_iti_center_permissions_delete: false,
  manage_iti_center_permissions_import: false,
  manage_iti_center_permissions_export: false,
  manage_district_permissions_create: false,
  manage_district_permissions_edit: false,
  manage_district_permissions_delete: false,
  manage_district_permissions_view: false,
  manage_district_permissions_import: false,
  manage_district_permissions_export: false,
  manage_year_permissions_create: false,
  manage_year_permissions_edit: false,
  manage_year_permissions_delete: false,
  manage_year_permissions_view: false,
  manage_center_type_permissions_create: false,
  manage_center_type_permissions_edit: false,
  manage_center_type_permissions_delete: false,
  manage_center_type_permissions_view: false,
  manage_trade_permissions_create: false,
  manage_trade_permissions_edit: false,
  manage_trade_permissions_delete: false,
  manage_trade_permissions_view: false,
  manage_trade_permissions_import: false,
  manage_trade_permissions_export: false,
  manage_bundle_type_permissions_create: false,
  manage_bundle_type_permissions_edit: false,
  manage_bundle_type_permissions_delete: false,
  manage_bundle_type_permissions_view: false,
  manage_role_permissions_create: false,
  manage_role_permissions_edit: false,
  manage_role_permissions_delete: false,
  manage_role_permissions_view: false,
  manage_user_permissions_create: false,
  manage_user_permissions_edit: false,
  manage_user_permissions_delete: false,
  manage_user_permissions_view: false,
  manage_exam_timetable_permissions_create: false,
  manage_exam_timetable_permissions_edit: false,
  manage_exam_timetable_permissions_delete: false,
  manage_exam_timetable_permissions_view: false,
  manage_notice_board_permissions_create: false,
  manage_notice_board_permissions_edit: false,
  manage_notice_board_permissions_delete: false,
  manage_notice_board_permissions_view: false,
  manage_doubt_permissions_answer: false,
  manage_doubt_permissions_view: false,
  manage_student_waiting_permissions_create: false,
  manage_student_waiting_permissions_edit: false,
  manage_student_waiting_permissions_delete: false,
  manage_student_waiting_permissions_view: false,
  manage_student_waiting_permissions_import: false,
  manage_student_waiting_permissions_actions: false,
  manage_student_approved_permissions_create: false,
  manage_student_approved_permissions_edit: false,
  manage_student_approved_permissions_delete: false,
  manage_student_approved_permissions_view: false,
  manage_student_approved_permissions_actions: false,
  manage_student_rejected_permissions_create: false,
  manage_student_rejected_permissions_edit: false,
  manage_student_rejected_permissions_delete: false,
  manage_student_rejected_permissions_view: false,
  manage_student_rejected_permissions_actions: false,
  manage_curriculum_permissions_create: false,
  manage_curriculum_permissions_edit: false,
  manage_curriculum_permissions_delete: false,
  manage_curriculum_permissions_view: false,
  manage_all_courses_permissions_create: false,
  manage_all_courses_permissions_edit: false,
  manage_all_courses_permissions_delete: false,
  manage_all_courses_permissions_view: false,
  manage_course_bundles_permissions_create: false,
  manage_course_bundles_permissions_edit: false,
  manage_course_bundles_permissions_delete: false,
  manage_course_bundles_permissions_view: false,
  manage_questions_permissions_create: false,
  manage_questions_permissions_edit: false,
  manage_questions_permissions_delete: false,
  manage_questions_permissions_view: false,
  manage_questions_permissions_import: false,
  manage_quiz_permissions_create: false,
  manage_quiz_permissions_edit: false,
  manage_quiz_permissions_delete: false,
  manage_quiz_permissions_view: false,
  manage_exam_permissions_create: false,
  manage_exam_permissions_edit: false,
  manage_exam_permissions_delete: false,
  manage_exam_permissions_view: false,
  manage_grand_test_permissions_create: false,
  manage_grand_test_permissions_edit: false,
  manage_grand_test_permissions_delete: false,
  manage_grand_test_permissions_view: false,
  manage_super_grand_test_permissions_create: false,
  manage_super_grand_test_permissions_edit: false,
  manage_super_grand_test_permissions_delete: false,
  manage_super_grand_test_permissions_view: false,
  manage_ebook_permissions_create: false,
  manage_ebook_permissions_edit: false,
  manage_ebook_permissions_delete: false,
  manage_ebook_permissions_view: false,
  manage_study_material_permissions_create: false,
  manage_study_material_permissions_edit: false,
  manage_study_material_permissions_delete: false,
  manage_study_material_permissions_view: false,
  manage_assignment_permissions_create: false,
  manage_assignment_permissions_edit: false,
  manage_assignment_permissions_delete: false,
  manage_assignment_permissions_view: false,
  manage_resource_permissions_create: false,
  manage_resource_permissions_edit: false,
  manage_resource_permissions_delete: false,
  manage_resource_permissions_view: false,
  manage_trade_time_table_permissions_create: false,
  manage_trade_time_table_permissions_edit: false,
  manage_trade_time_table_permissions_delete: false,
  manage_trade_time_table_permissions_view: false,
  manage_examination_guideline_permissions_create: false,
  manage_examination_guideline_permissions_edit: false,
  manage_examination_guideline_permissions_delete: false,
  manage_examination_guideline_permissions_view: false,
  manage_live_session_permissions_create: false,
  manage_live_session_permissions_view: false,
  manage_live_session_permissions_edit: false,
  manage_live_session_permissions_delete: false,
  manage_discussion_forum_permissions_create: false,
  manage_discussion_forum_permissions_edit: false,
  manage_discussion_forum_permissions_delete: false,
  manage_discussion_forum_permissions_view: false,
};
export const permissionSlice = createSlice({
  name: "permissions",
  initialState: initialState,
  reducers: {
    handleChangePermissions(
      state: any,
      action: PayloadAction<Record<string, boolean | null>>
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const selectPermissions = (state: any) => state.permissionSlice;

export const { handleChangePermissions } = permissionSlice.actions;

export default permissionSlice.reducer;
